<template>

  <span>
    <span v-for="lang in langs" v-on:click.prevent="set_lang(lang)" v-bind:class="get_active(lang)">{{ lang }}</span>
  </span>

</template>

<script>
export default{

  data () {
    return {
      current_lang: '',
      langs: ['de', 'en', 'ru']
    }
  },
  methods: {
    get_active (lang) {
      if (this.current_lang == lang) { return {'hit-html-strong': true} }
    },
    set_lang (lang) {
      this.current_lang = lang
      this.$i18n.locale = lang
      this.$store.commit('set_lang', lang)
      this.$route.params.lang = lang

      this.$router.push({ name: this.$route.name, params: this.$route.params })
    }
  },

  mounted () {
    if (this.$store.getters.lang) { this.current_lang = this.$store.getters.lang }
  }
}
</script>

<style scoped>
  span{
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
  }
  span:hover,span:focus{
    text-decoration: none;
  }
  span:first-of-type:before{
    content: ""
  }
  span:after{
    content: " |";
    font-weight: normal;
  }
  span:before{
    content: " "
  }
  span:last-of-type:after{
    content: ""
  }
</style>
